import React, { useCallback, useEffect, useRef, useState } from "react";

// Images and Icons
import InterlinkLogo from "assets/images/interlink_logo.png";
import KeyboardArrowDownIcon from "assets/icons/general/KeyboardArrowDownIcon";
import MenuIcon from "assets/icons/general/MenuIcon";

// Data
import { navLinks } from "utils/constants/data";
import { getDomainITPL } from "utils/helpers";

function Navbar({ scrolled, setMenuOpen }) {
  const dropdownRef = useRef(null);
  const buttonRef = useRef([]);
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const handleMouseDown = useCallback(
    (e) => {
      if (
        dropdownOpen &&
        !dropdownRef?.current?.contains(e.target) &&
        !buttonRef.current?.[dropdownOpen]?.contains(e.target)
      ) {
        setDropdownOpen(false);
      }
    },
    [dropdownOpen, setDropdownOpen]
  );

  useEffect(() => {
    window.addEventListener("mousedown", handleMouseDown);
    return () => {
      window.removeEventListener("mousedown", handleMouseDown);
    };
  }, [handleMouseDown]);

  return (
    <nav
      className={`sticky top-0 ${
        scrolled ? "shadow-md bg-interlink-white" : "bg-interlink-white"
      } transition-all duration-300 z-20`}
    >
      <div className="flex w-full justify-between items-center max-w-navigation py-4 lg:py-6">
        <a href={getDomainITPL()} className="flex items-center">
          <img
            className="h-[80px] sm:h-[100px] object-contain"
            src={InterlinkLogo}
            alt="interlink_logo"
          />
        </a>
        <ul
          className="hidden xl:flex flex-1 justify-end gap-6 xl:gap-8 items-center font-semibold"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          {navLinks.map((item, i) => (
            <li key={i}>
              <a
                ref={(el) => (buttonRef.current[i] = el)}
                href={item?.path}
                className={`flex items-center gap-2 cursor-pointer select-none text-sm 2xl:text-base  hover:border-b hover:border-interlink-blue hover:text-interlink-blue hover:pb-1 hover:-mb-1 transition-all duration-500 group ${
                  window.location.pathname === item.path
                    ? "text-interlink-blue border-b border-interlink-blue pb-1 -mb-1"
                    : "text-interlink-dark-grey border-b border-transparent pb-1 -mb-1"
                }`}
                onClick={() =>
                  setDropdownOpen((prev) => (prev === i ? null : i))
                }
              >
                {item.label}
                {item.dropdownItems?.length > 0 && (
                  <KeyboardArrowDownIcon
                    className={`h-5 w-4 fill-interlink-dark-grey group-hover:fill-interlink-blue ${
                      dropdownOpen === i ? "rotate-180" : "rotate-0"
                    } transition-all duration-300`}
                  />
                )}
              </a>
            </li>
          ))}
        </ul>
        <button
          className="flex items-center xl:hidden"
          onClick={() => setMenuOpen(true)}
        >
          <MenuIcon width="30" height="30" />
        </button>
      </div>
      {navLinks?.[dropdownOpen]?.dropdownItems && (
        <div
          ref={dropdownRef}
          className={`hidden sm:block absolute bg-interlink-white left-0 right-0 shadow-md border-t border-interlink-dark-grey-4`}
        >
          <div className="py-4 lg:py-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {navLinks?.[dropdownOpen]?.dropdownItems.map((item, i) => {
              return (
                <a
                  key={i}
                  href={`${item.path}`}
                  className={`font-semibold text-center text-base lg:text-sm 2xl:text-base select-none space-x-4 hover:text-interlink-blue transition-all duration-500  ${
                    window.location.pathname === item.path
                      ? "text-interlink-blue"
                      : "text-interlink-dark-grey"
                  }`}
                >
                  <p>{item.label}</p>
                </a>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
